import type {
	CollaborationGraphEntities,
	CollaborationGraphEntity,
	Collaborator,
	Collaborators,
} from '../types';

const COLLABORATION_GRAPH_MAX_RESULTS = 50;

export const getUsersFromCollaborationGraph = async (
	confluenceCloudId: string,
	userId: string,
): Promise<Collaborators> => {
	const payload = {
		context: {
			contextType: 'inviteOnLinkInsertConfluence',
			principalId: userId,
			siteId: confluenceCloudId,
		},
		modelRequestParams: {
			experience: 'CgUserNearbyUser',
		},
		expanded: true,
		maxNumberOfResults: COLLABORATION_GRAPH_MAX_RESULTS,
		userId,
	};

	const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(payload),
	});

	const result = ((await response.json()) as CollaborationGraphEntities).collaborationGraphEntities
		.filter(
			(en): en is CollaborationGraphEntity & { userProfile: Collaborator } =>
				en?.userProfile !== undefined &&
				en?.userProfile?.account_type !== 'app' &&
				en?.userProfile?.account_status !== 'deactivated' &&
				en?.userProfile?.account_status !== 'deleted',
		)
		.map(({ userProfile: { account_id, name, email, picture } }) => ({
			id: account_id,
			name,
			email,
			avatar: picture,
		}));
	return result;
};
